import React from 'react';
import ContactCard from '../Components/ContactCard/ContactCard';
import Stack from 'react-bootstrap/Stack';
import useSiteContent, { safeLink } from '../Content/useSiteContent';
import ContentNotice from '../Content/ContentNotice';

const Membership = () => {
  const { data, unavailable } = useSiteContent('membership');
  const applicationUrl = safeLink(data.applicationUrl);
  return <div>
    <ContentNotice unavailable={unavailable} />
    <div className="membership_main_container">
      <div className="membership_left">
        <Stack gap={2}>
          <h1 className="membership_centered_text">{data.heading}</h1>
          <h3 className="membership_centered_text editable-text">{data.intro}</h3>
          <br />
          <h3 className="membership_centered_text editable-text">{data.applicationsOpen ? data.openMessage : data.closedMessage}</h3>
          {data.applicationsOpen && applicationUrl && <p className="membership_centered_text">
            <a className="application-link" href={applicationUrl} target="_blank" rel="noopener noreferrer">{data.applicationLabel}</a>
          </p>}
        </Stack>
      </div>
      <div className="membership_right"><ContactCard /></div>
    </div>
  </div>;
};
export default Membership;
